module.exports = __webpack_public_path__ + "img/iconpdf.c794cc5d.svg";